import { createTheme } from '../utils/createTheme';
export default createTheme(function () {
  return {
    mode: 'light'
  };
});